import Cookies from 'js-cookie'
import jstz from 'jstz'

// Rails doesn't support every timezone that Intl supports
export function findTimeZone() {
  const oldIntl = globalThis.Intl
  try {
    globalThis.Intl = undefined
    const tz = jstz.determine().name()
    globalThis.Intl = oldIntl
    return tz
  } catch (e) {
    // sometimes (on android) you can't override intl
    console.warn('Could not override Intl, falling back to jstz default', e)
    return jstz.determine().name()
  }
}

document.addEventListener("turbo:load", () => {
  Cookies.set("browser_time_zone", findTimeZone(), { expires: 365, path: "/", secure: true })
})
